import { Button as AntButton, Descriptions, Modal } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getAbsenceRefund } from '../../../../api/campusClasses.api';
import { checkAbsenceRefunds, submitAbsenceRefunds } from '../../../../api/refunds.api';
import useAxios from '../../../../hooks/useAxios';
import useNotification from '../../../../hooks/useNotification';
import { IGetAbsenceRefund } from '../../../../models/campusClasses.model';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';
import Radio from '../../../Radio';
import { IResponse } from '../../../../models/common.api.model';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  attendCode: number | undefined;
  doGetRollbook: () => void;
}

const ShowRefundModal: FC<IProps> = ({
                                       visible,
                                       setVisible,
                                       attendCode,
                                       doGetRollbook,
                                     }) => {
  const { t } = useTranslation();
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetAbsenceRefund>();
  const {
    data: checkRes,
    isLoading: checkIsLoading,
    error: checkError,
    execute: checkExecute,
  } = useAxios<IResponse<boolean>>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [amount, setAmount] = useState<number>();
  const [type, setType] = useState<'RE' | 'CO'>('RE');

  useEffect(() => {
    if (attendCode) {
      execute(getAbsenceRefund(attendCode));
    }
  }, [attendCode]);

  useEffect(() => {
    if (res?.data && isLoading) {
      setAmount(res.data.price);
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      doGetRollbook();
      setVisible(false);
      successNotification(t('common.button.processed'));
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (checkRes) {
      console.log(checkRes);
      if (checkRes.data) {
        if (!attendCode) return;

        if (!amount) {
          return infoNotification(t('class.class.message28'));
        }

        submitExecute(submitAbsenceRefunds({
          type,
          attendCodes: [attendCode],
          amount,
        }));
      } else {
        infoNotification(t('환불 대기 중인 결제건입니다. 환불을 완료 후 다시 시도해 주세요'));
      }
    }
  }, [checkRes]);

  const onSubmit = () => {
    if (!attendCode) return;

    if (!amount) {
      return infoNotification(t('class.class.message28'));
    }

    checkExecute(checkAbsenceRefunds({
      type,
      attendCodes: [attendCode],
      amount,
    }));
  };


  return (
    <>
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />

      <Modal
        title={t('class.class.title12')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className="comm-btn__area justify-content-center">
            <AntButton
              key="submit"
              className="btn-basic pink"
              onClick={onSubmit}
            >
              {t('class.class.column46')}
            </AntButton>
            <AntButton
              key="cancel"
              className="btn-basic gray"
              onClick={() => setVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>,
        ]}
      >
        <Descriptions
          bordered
          column={1}
          size="small"
          labelStyle={{ textAlign: 'center', width: '50%' }}
        >
          <Descriptions.Item label={t('class.class.column79')}>
            <input
              type="text"
              className="form-control w-150p"
              value={amount}
              onChange={e => setAmount(Number(e.target.value))}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('class.class.column80')}>
            <Radio
              checked={type === 'RE'}
              onChange={() => setType('RE')}
              text={t('class.class.column46')}
            />
            <Radio
              className="ml-4"
              checked={type === 'CO'}
              onChange={() => setType('CO')}
              text={t('class.class.option3')}
            />
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    </>
  );
};

export default ShowRefundModal;
